export default __webpack_public_path__ + "static/media/planet-4.32709d8a.svg";